import styled from '@emotion/styled';
import { colors } from 'theme/colors';

export const ModalContent = styled('div')(`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow: hidden;
    background-color: ${colors.white};
    border-radius: 8px;
    border: 1px solid ${colors.primary500};
    padding: 32px;
    margin: auto;
    box-shadow: 0px 7px 14px 0px #053A6812, 0px 7px 7px 0px #053A6826;
    overflow-y: auto;
    max-height: 98vh;
    ::-webkit-scrollbar {
      width: 12px;
      background-clip: padding-box;
      border-radius: 25px;
    };
    ::-webkit-scrollbar-track {
      background-color: #dfdfe2;;
      border-radius: 5px;
      margin-top: 8px
      margin-bottom: 8px;
      background-clip: padding-box;
    };
    ::-webkit-scrollbar-thumb {
      background-color: #aaaaaf;
      border-radius: 5px;
      border: 2px solid #dfdfe2;;
      background-clip: padding-box;
    };

    & .modal-title {
      margin: 0;
      line-height: 1.5rem;
      margin-bottom: 8px;
    }

    & .modal-description {
      margin: 0;
      line-height: 1.5rem;
      font-weight: 400;
      margin-bottom: 4px;
    }
  `);

export const CustomModalRoot = styled('div')`
  position: fixed;
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
`;
